export default "__VITE_ASSET__efc531d0__"